// src/pages/GuestCart.jsx
import { useState, useEffect } from "react";
import React from "react";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";

const GuestCart = () => {
  const navigate = useNavigate();

  const [cartItems, setCartItems] = useState([]);
  const [totalPrice, setTotalPrice] = useState("0.0");
  const [showModal, setShowModal] = useState(false);

  const CART_KEY = "cart";

  const readCart = () => {
    try {
      const raw = localStorage.getItem(CART_KEY);
      if (!raw) return [];
      return JSON.parse(raw);
    } catch (e) {
      console.error("Failed to read cart", e);
      return [];
    }
  };

  const writeCart = (items) => {
    try {
      localStorage.setItem(CART_KEY, JSON.stringify(items));
    } catch (e) {
      console.error("Failed to write cart", e);
    }
  };

  useEffect(() => {
    const items = readCart();
    setCartItems(items);
    const total = items.reduce(
      (acc, it) => acc + Number(it.totalPrice || 0),
      0
    );
    setTotalPrice(total.toFixed(2));
  }, []);

  const refreshCartState = () => {
    const items = readCart();
    setCartItems(items);
    const total = items.reduce(
      (acc, it) => acc + Number(it.totalPrice || 0),
      0
    );
    setTotalPrice(total.toFixed(2));
  };

  const removeItem = (productId, categorySizeId = null) => {
    const items = readCart().filter(
      (it) =>
        !(
          String(it.productId) === String(productId) &&
          String(it.categorySizeId) === String(categorySizeId)
        )
    );
    writeCart(items);
    refreshCartState();
    alert("Item removed from cart");
  };

  const handleCheckout = () => {
    navigate("/user/login");
  };

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  return (
    <div className="mt-3">
      <div
        className="card form-card ms-2 me-2 mb-5 custom-bg"
        style={{
          height: "45rem",
        }}
      >
        <div className="card-header text-center bg-color custom-bg-text">
          <h2>My Cart</h2>
        </div>

        <div
          className="card-body"
          style={{
            overflowY: "auto",
          }}
        >
          <div className="table-responsive">
            <table className="table table-hover custom-bg-text text-center">
              <thead className="bg-color table-bordered border-color">
                <tr>
                  <th scope="col">Product</th>
                  <th scope="col">Name</th>
                  <th scope="col">Quantity</th>
                  <th scope="col">Size</th>
                  <th scope="col">Unit Price</th>
                  <th scope="col">Line Total</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody className="text-color">
                {cartItems.length === 0 && (
                  <tr>
                    <td colSpan="8">
                      <b>Your cart is empty</b>
                    </td>
                  </tr>
                )}

                {cartItems.map((item, idx) => {
                  const imageUrl = item.productImage
                    ? "https://goldenhides.in/api/product/" + item.productImage
                    : "";

                  const sizeReadable = item.size || item.categorySizeId || "";

                  return (
                    <tr key={idx}>
                      <td>
                        {imageUrl ? (
                          <img
                            src={imageUrl}
                            alt="product_pic"
                            className="img-fluid"
                            style={{ maxWidth: "90px" }}
                          />
                        ) : (
                          <div
                            style={{
                              width: 90,
                              height: 70,
                              background: "#f2f2f2",
                            }}
                          />
                        )}
                      </td>

                      <td>
                        <b>{item.productName || "-"}</b>
                      </td>

                      <td>
                        <b>{item.quantity}</b>
                      </td>

                      <td>
                        <b>{sizeReadable}</b>
                      </td>

                      <td>
                        <b>&#8377; {Number(item.price || 0).toFixed(2)}</b>
                      </td>

                      <td>
                        <b>&#8377; {Number(item.totalPrice || 0).toFixed(2)}</b>
                      </td>

                      <td>
                        <button
                          className="btn bg-color custom-bg-text btn-sm"
                          onClick={() =>
                            removeItem(item.productId, item.categorySizeId)
                          }
                        >
                          Delete
                        </button>
                        <ToastContainer />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        <div className="card-footer custom-bg">
          <div className="float-right" style={{ width: "100%" }}>
            {cartItems.length > 0 && (
              <div className="d-flex justify-content-end align-items-center gap-3">
                <div className="text-color me-2" style={{ textAlign: "right" }}>
                  <h5>
                    Total Price: <span>&#8377; {totalPrice}</span>
                  </h5>
                  <div className="text-muted">
                    Items:{" "}
                    {cartItems.reduce((a, b) => a + Number(b.quantity || 0), 0)}
                  </div>
                </div>

                <div>
                  <button
                    type="button"
                    className="btn bg-color custom-bg-text mb-3"
                    onClick={handleCheckout}
                  >
                    Checkout
                  </button>
                </div>
              </div>
            )}

            {cartItems.length === 0 && (
              <div className="text-center text-color">
                <b>Your cart is empty. Browse products to add items.</b>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuestCart;
